import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute — 인증되지 않은 사용자를 /login으로 리다이렉트하는 래퍼 컴포넌트
 *
 * - isLoading 중에는 로딩 UI를 표시한다.
 * - 미인증 시 <Navigate to="/login" replace />로 리다이렉트한다.
 * - 인증된 사용자에게는 children을 렌더링한다.
 *
 * @param {{ children: React.ReactNode }} props
 * @returns {React.ReactElement}
 *
 * Validates: Requirements 1.3
 */
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <span>로딩 중...</span>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
